"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAndClearTempDataFromStorage = exports.setTempDataToStorage = exports.formatCheckoutFormSpecToAntdOptions = exports.getCvs = exports.cartInitialData = exports.cvsInitialData = void 0;
var Cart = __importStar(require("../../Actions/Cart"));
var AsyncStorage = __importStar(require("../../Utils/AsyncStorage"));
var query_string_1 = __importDefault(require("query-string"));
var cvsInitialData = {
  MerchantTradeNo: '',
  CVSStoreID: '',
  CVSStoreName: '',
  CVSAddress: '',
  CVSTelephone: '',
  CVSOutSide: ''
};
exports.cvsInitialData = cvsInitialData;
var cartInitialData = {
  buyer_address: '',
  buyer_city: '',
  buyer_district: '',
  buyer_email: '',
  buyer_name: '',
  buyer_phone: '',
  buyer_tel: '',
  buyer_tel_ext: '',
  buyer_zip: '',
  discount_items: [],
  extra_data: null,
  extra_items: [],
  fee: 0,
  invoice_carrier_num: '',
  invoice_carrier_type: '',
  invoice_category: '',
  invoice_donation: '',
  invoice_love_code: '',
  invoice_uni_no: '',
  items: [],
  logistics_cvs_store_id: '',
  logistics_subtype: '',
  logistics_type: '',
  order_note: '',
  owner: '',
  payment_subtype: '',
  receiver_address: '',
  receiver_city: '',
  receiver_district: '',
  receiver_email: '',
  receiver_name: '',
  receiver_phone: '',
  receiver_tel: '',
  receiver_tel_ext: '',
  receiver_zip: '',
  sales: 0,
  subtotal: 0,
  tax: 0,
  total: 0,
  use_full_points: false,
  points: 0,
  invoice_type: '',
  b2b_company_name: '',
  b2b_company_no: '',
  b2c_phone_carrier_code: '',
  b2c_donate_code: '',
  b2c_npc_code: ''
};
exports.cartInitialData = cartInitialData;
// TODO: add unit test
function getCvs(values) {
  function mapCvsInfo(values) {
    return {
      MerchantTradeNo: values.MerchantTradeNo,
      CVSStoreID: values.CVSStoreID,
      CVSStoreName: values.CVSStoreName,
      CVSAddress: values.CVSAddress,
      CVSTelephone: values.CVSTelephone,
      CVSOutSide: values.CVSOutSide
    };
  }
  if (!!window.location.search) {
    var parsed = query_string_1.default.parse(window.location.search || '');
    return mapCvsInfo(parsed);
  } else if (!!(values === null || values === void 0 ? void 0 : values.CVSStoreID)) {
    return mapCvsInfo(values);
  }
  return cvsInitialData;
}
exports.getCvs = getCvs;
// TODO: add unit test
var formatCheckoutFormSpecToAntdOptions = function formatCheckoutFormSpecToAntdOptions(checkoutFormSpec, nextConfig, options) {
  var _a;
  var _b, _c;
  if (options === void 0) {
    options = {};
  }
  var paymentSubTypeOpts = checkoutFormSpec.paymentSubTypes.map(function (ps) {
    return Cart.PAYMENT_SUBTYPE_DISPLAY[ps];
  });
  var logisticsTypeOpts = checkoutFormSpec.logisticsTypes.map(function (l) {
    if (l === Cart.LOGISTICS_TYPE.custom) {
      return {
        value: l,
        label: options.customLogisticsDisplay || '其他'
      };
    }
    return Cart.LOGISTICS_TYPE_DISPLAY[l];
  });
  var logisticSubTypeOptsSet = (_a = {}, _a[Cart.LOGISTICS_TYPE.cvs] = checkoutFormSpec.logisticsSubTypes[Cart.LOGISTICS_TYPE.cvs].map(function (ls) {
    return Cart.LOGISTICS_SUBTYPE_DISPLAY[ls];
  }), _a[Cart.LOGISTICS_TYPE.home] = checkoutFormSpec.logisticsSubTypes[Cart.LOGISTICS_TYPE.home].map(function (ls) {
    return Cart.LOGISTICS_SUBTYPE_DISPLAY[ls];
  }), _a[Cart.LOGISTICS_TYPE.oversea] = checkoutFormSpec.logisticsSubTypes[Cart.LOGISTICS_TYPE.oversea].map(function (ls) {
    return Cart.LOGISTICS_SUBTYPE_DISPLAY[ls];
  }), _a);
  var logisticSubTypeOpts = logisticSubTypeOptsSet[nextConfig.logistics_type];
  var invoiceCategoryOpts = ((_b = checkoutFormSpec === null || checkoutFormSpec === void 0 ? void 0 : checkoutFormSpec.invoiceCategories) === null || _b === void 0 ? void 0 : _b.map(function (ic) {
    return Cart.INVOICE_CATEGORY_DISPLAY[ic];
  })) || [];
  var invoiceCarrierTypeOpts = ((_c = checkoutFormSpec === null || checkoutFormSpec === void 0 ? void 0 : checkoutFormSpec.invoiceCarrierTypes) === null || _c === void 0 ? void 0 : _c.map(function (ic) {
    return Cart.INVOICE_CARRIER_TYPE_DISPLAY[ic];
  })) || [];
  var invoiceTypeOpts = (checkoutFormSpec.invoiceTypes || []).map(function (opt) {
    return {
      label: Cart.INVOICE_TYPE_DISPLAY[opt],
      value: opt
    };
  });
  return {
    paymentSubTypeOpts: typeof options.remapPaymentSubTypeOpts === 'function' ? paymentSubTypeOpts.map(options.remapPaymentSubTypeOpts) : paymentSubTypeOpts,
    logisticsTypeOpts: logisticsTypeOpts,
    logisticSubTypeOptsSet: logisticSubTypeOptsSet,
    logisticSubTypeOpts: logisticSubTypeOpts,
    invoiceCategoryOpts: invoiceCategoryOpts,
    invoiceCarrierTypeOpts: invoiceCarrierTypeOpts,
    invoiceTypeOpts: invoiceTypeOpts
  };
};
exports.formatCheckoutFormSpecToAntdOptions = formatCheckoutFormSpecToAntdOptions;
function setTempDataToStorage(values) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, AsyncStorage.setItem('temp-checkout-form-data', JSON.stringify(values))];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}

exports.setTempDataToStorage = setTempDataToStorage;
function getAndClearTempDataFromStorage() {
  return __awaiter(this, void 0, void 0, function () {
    var storedCart, _a, _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _b = (_a = JSON).parse;
          return [4 /*yield*/, AsyncStorage.getItem('temp-checkout-form-data')];
        case 1:
          storedCart = _b.apply(_a, [_c.sent() || 'null']) || null;
          if (!storedCart) {
            return [2 /*return*/, null];
          }
          return [4 /*yield*/, AsyncStorage.removeItem('temp-checkout-form-data')];
        case 2:
          _c.sent();
          return [2 /*return*/, {
            buyer_name: storedCart.buyer_name,
            buyer_phone: storedCart.buyer_phone,
            buyer_email: storedCart.buyer_email,
            buyer_tel: storedCart.buyer_tel,
            buyer_tel_ext: storedCart.buyer_tel_ext,
            buyer_zip: storedCart.buyer_zip,
            buyer_city: storedCart.buyer_city,
            buyer_district: storedCart.buyer_dsitrict,
            buyer_address: storedCart.buyer_address,
            receiver_name: storedCart.receiver_name,
            receiver_phone: storedCart.receiver_phone,
            receiver_email: storedCart.receiver_email,
            receiver_tel: storedCart.receiver_tel,
            receiver_tel_ext: storedCart.receiver_tel_ext,
            receiver_zip: storedCart.receiver_zip,
            receiver_city: storedCart.receiver_city,
            receiver_district: storedCart.receiver_dsitrict,
            receiver_address: storedCart.receiver_address,
            invoice_carrier_num: storedCart.invoice_carrier_num,
            invoice_carrier_type: storedCart.invoice_carrier_type,
            invoice_love_code: storedCart.invoice_love_code,
            invoice_donation: storedCart.invoice_donation,
            invoice_uni_no: storedCart.invoice_uni_no,
            invoice_category: storedCart.invoice_category,
            order_note: storedCart.order_note
          }];
      }
    });
  });
}
exports.getAndClearTempDataFromStorage = getAndClearTempDataFromStorage;